import React from "react"
import { ForgeRockCallbackProps } from "@models/forgeRock.model"
import { NameCallbackInput } from "./NameCallbackInput"
import { PasswordCallbackInput } from "./PasswordCallbackInput"

export const ForgeRockCallbackRenderer: React.FC<ForgeRockCallbackProps> = ({
	callback,
	index,
	currentStepNumber,
	callbackValues,
	updateCallbackValue,
	isLoading,
	hasError,
	loginFormComponentData
}) => {
	const callbackType = callback.getType?.() || callback.type

	switch (callbackType) {
		case "NameCallback":
			return (
				<NameCallbackInput
					callback={callback}
					index={index}
					currentStepNumber={currentStepNumber}
					callbackValues={callbackValues}
					updateCallbackValue={updateCallbackValue}
					isLoading={isLoading}
					hasError={hasError}
					loginFormComponentData={loginFormComponentData}
				/>
			)

		case "PasswordCallback":
			return (
				<PasswordCallbackInput
					callback={callback}
					index={index}
					currentStepNumber={currentStepNumber}
					callbackValues={callbackValues}
					updateCallbackValue={updateCallbackValue}
					isLoading={isLoading}
					hasError={hasError}
					loginFormComponentData={loginFormComponentData}
				/>
			)

		default:
			return null
	}
}
